import { Checkbox } from './Checkbox';

export function setupCheckboxes() {
  const inputs = document.querySelectorAll('input[type=checkbox]');
  for (const input of inputs) {
    new Checkbox(input as HTMLInputElement);
  }
}
